export default __webpack_public_path__ + "static/media/sbcHeaderLogo.1e723a42.png";